

















import { Prop, Vue, Watch } from "vue-property-decorator";
import Component from "vue-class-component";

@Component({})
export default class NotificationCard extends Vue {
  @Prop({ default: "primary", type: String }) type!: string;
  @Prop() title!: string;
  @Prop() desc!: string;
  //automatically visible on page rendered so that disappears auto after 10 sec
  @Prop() bootVisible!: string;
  mode!: string;
  notificationId = "notId";

  get typeClass() {
    this.mode = this.type;
    const classes = [`notification ${this.mode}`];
    return classes;
  }

  async mounted() {
    if (
      this.bootVisible === null ||
      this.bootVisible === undefined ||
      this.bootVisible === ""
    )
      this.bootVisible = "false";
    if (this.notificationId === "notId") {
      this.notificationId =
        "notificationId" +
        Math.random()
          .toString(16)
          .slice(2);
      (document.getElementById(
        "notId"
      ) as HTMLElement).id = this.notificationId;
    }
    if (this.bootVisible === "false")
      (document.getElementById(
        this.notificationId
      ) as HTMLElement).style.display = "none";

    //default wert != true
    if (this.bootVisible === "true")
      setTimeout(this.destroyNotification, 10000);
  }

  @Watch("bootVisible")
  onVisibilityChanged() {
    if (this.bootVisible === "true") {
      (document.getElementById(
        this.notificationId
      ) as HTMLElement).style.display = "flex";
      setTimeout(this.destroyNotification, 10000);
    }
  }

  async closeNotification() {
    (document.getElementById(
      this.notificationId
    ) as HTMLElement).style.display = "none";
  }

  async destroyNotification() {
    (document.getElementById(
      this.notificationId
    ) as HTMLElement).style.display = "none";
    this.bootVisible = "false";
  }
}
